import { stateMeGnosisPay } from '$states/meGnosisPay.svelte';
import { Guard, type GuardRun } from '../utils/Guard';

export class RequireActiveGnosisPayAccount extends Guard implements GuardRun {
  run() {
    if (
      !this.target.includes('/card/status') &&
      stateMeGnosisPay.current &&
      stateMeGnosisPay.current.kycStatus === 'rejected'
    ) {
      return this.redirectTo('/card/status');
    }
  }
}
